"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ripple_keypairs_1 = require("ripple-keypairs");
exports.deriveKeypair = ripple_keypairs_1.deriveKeypair;
exports.deriveAddress = ripple_keypairs_1.deriveAddress;
//# sourceMappingURL=derive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/offline/derive.js
// module id = 4tSA
// module chunks = 0